export const SKILL_DEFAULT_PRACTICE_LEVEL = 1;

export const skillSteps = ['Select Skills', 'Reflect on them'];

export const ME_NEXT = 'MeNext';
export const BOTH_ME_NOW_AND_ME_NEXT = 'BothMeNowAndMeNext';
